import { Component } from '@angular/core';
import { ChartComponent } from '../charts/chart.component';
import { FilteredReport } from '../filtered-report';
import { FiltersComponent } from '../filters/filters.component';
import { ClaimsData, EmploymentType } from '../workforce.types';
import { CLAIMS_SERIES } from '../report-presentation';

@Component({ selector: 'app-claims', standalone: false, templateUrl: './claims.component.html', styles: [`
.rejected-expense-card { position: relative; }
.expense-breakdown { display: none; position: absolute; z-index: 30; top: calc(100% + 6px); left: 0; min-width: 230px; max-height: 260px; overflow: auto; padding: 12px; border: 1px solid #d8cce6; border-radius: 8px; background: #fff; box-shadow: 0 4px 16px #34354f26; color: #34354f; font-size: 13px; }
.rejected-expense-card:hover .expense-breakdown, .rejected-expense-card:focus-within .expense-breakdown { display: block; }
.expense-breakdown ul { list-style: none; margin: 8px 0 0; padding: 0; }
.expense-breakdown li { display: flex; justify-content: space-between; gap: 18px; margin: 4px 0; }
`] })
export class ClaimsComponent extends FilteredReport<ClaimsData> {
  override employmentType: EmploymentType = 'On-Roll';
  protected override get defaultEmploymentType(): EmploymentType { return 'On-Roll'; }
  protected readonly endpoint = '/workforce/expense-summary';
  protected readonly fallbackError = 'Unable to load expenses. Please reload or change the filters to try again.';
  readonly series = CLAIMS_SERIES;
  get groupLabel(): string { return this.groupBy.charAt(0).toUpperCase() + this.groupBy.slice(1); }
}
